export default "__VITE_ASSET__CSrMKD_n__"